import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { RippleModule } from 'primeng/ripple';
import { TableModule } from 'primeng/table';

import { AccountArrangementLocalityListComponent } from './account-arrangement-locality-list.component';
import { CardModule } from 'primeng/card';

@NgModule({
  declarations: [AccountArrangementLocalityListComponent],
  imports: [CommonModule, TableModule, ButtonModule, RippleModule, InputTextModule, CardModule],
})
export class AccountArrangementLocalityListModule {}
